window.currencySymbols = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CHF: "CHF",
  CAD: "$",
  AUD: "$",
  NZD: "$",
  CNY: "¥",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  PLN: "zł",
  HUF: "Ft",
  CZK: "Kč"
};

function formatMoney(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
  return window.Shopify.formatMoney(cents);
  }

  return (cents / 100).toLocaleString();
}

function formatMoneyWithCurrency(cents, currency) {
  const symbol = window.currencySymbols?.[currency] || currency;

  const amount = (cents / 100).toLocaleString(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
  });

  return `${symbol} ${amount}`;
}

/***
 FOOTER
***/

document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.js-accordion-trigger');

  const toggleAccordion = (trigger) => {
    if (window.innerWidth >= 768) return;

    const content = trigger.nextElementSibling;
    const icon = trigger.querySelector('.js-accordion-icon');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    triggers.forEach(otherTrigger => {
      if (otherTrigger !== trigger) {
        otherTrigger.setAttribute('aria-expanded', 'false');
        if (otherTrigger.nextElementSibling) {
          otherTrigger.nextElementSibling.classList.add('hidden');
        }
        const otherIcon = otherTrigger.querySelector('.js-accordion-icon');
        if (otherIcon) {
          otherIcon.classList.remove('rotate-180');
        }
      }
    });

    if (isExpanded) {
      trigger.setAttribute('aria-expanded', 'false');
      content.classList.add('hidden');
      if (icon) icon.classList.remove('rotate-180');
    } else {
      trigger.setAttribute('aria-expanded', 'true');
      content.classList.remove('hidden');
      if (icon) icon.classList.add('rotate-180');
    }
  };

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => toggleAccordion(trigger));
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 768) {
      document.querySelectorAll('.js-accordion-content').forEach(content => {
        content.classList.remove('hidden');
      });
      triggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'true');
        const icon = trigger.querySelector('.js-accordion-icon');
        if (icon) icon.classList.remove('rotate-180');
      });
    } else {
      document.querySelectorAll('.js-accordion-content').forEach(content => {
        content.classList.add('hidden');
      });
      triggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
});